import 'react-hot-loader/patch';
import React from 'react';
import axios from 'axios';
import { wixAxiosConfig } from '@wix/wix-axios-config';
import Modal from 'react-modal';
import initI18n from '@wix/da-i18next/pkg/presetI18nClientConfig';
import App from './components/App';
import { AppContainer } from 'react-hot-loader';
import { configureStore } from './store/configure-store';
import { getClientInstance } from '@wix/da-ddt';
import { configureHistoryListener } from '@wix/da-shared-react/pkg/redux/routing/history';
import { XHR_BASE_PATH } from '../constants';
import DaAppWrapper from '@wix/da-shared-react/pkg/DaApp/DaAppWrapper';
import { hydrateRoot } from 'react-dom/client';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';
import AppDocumentWrapper from '@wix/da-react-app/pkg/client/AppDocumentWrapper/AppDocumentWrapper';

const ddt = getClientInstance();
ddt.replayServerSideLogs(window['__DDT__']);

const initialI18n = window['__INITIAL_I18N__'];

const initialState = window['__INITIAL_STATE__'];
delete window['__INITIAL_STATE__'];
const store = configureStore(initialState);
const state = store.getState();
configureHistoryListener(store);

initI18n(
  initialI18n,
  getEnv(store.getState()).isDebug,
  getEnv(store.getState()).flags
);

wixAxiosConfig(axios, { baseURL: XHR_BASE_PATH });

if (state.isStash || getEnv(state).flags?.includes('seo_r18_async')) {
  // Stash uses r18 stream rendering
  const root = hydrateRoot(
    document,
    <AppDocumentWrapper store={store}>
      <App language={initialI18n.locale} />
    </AppDocumentWrapper>
  );

  if (module.hot) {
    module.hot.accept('./components/App', () => {
      // eslint-disable-next-line global-require
      const AppLatest = require('./components/App').default;
      root.render(
        <AppContainer>
          <AppDocumentWrapper store={store}>
            <AppLatest language={initialI18n.locale} />
          </AppDocumentWrapper>
        </AppContainer>
      );
    });
  }
} else {
  // Non Stream rendering

  Modal.setAppElement('#root');

  const root = hydrateRoot(
    document.getElementById('root')!,
    <DaAppWrapper store={store}>
      <App language={initialI18n.locale} />
    </DaAppWrapper>
  );

  if (module.hot) {
    module.hot.accept('./components/App', () => {
      // eslint-disable-next-line global-require
      const AppLatest = require('./components/App').default;
      root.render(
        <AppContainer>
          <DaAppWrapper store={store}>
            <AppLatest language={initialI18n.locale} />
          </DaAppWrapper>
        </AppContainer>
      );
    });
  }
}
